import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  icon: { marginRight: 8 },
  error: {
    height: '40vh',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    color: colors.gilead.primary1,
    fontSize: 22,
    '& svg': {
      height: 22,
      width: 22,
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
      '& svg': {
        height: 18,
        width: 18,
      },
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      '& svg': {
        height: 14,
        width: 14,
      },
    },
  },
}));
